var render = function render(){var _vm=this,_c=_vm._self._c;return _c('line-chart',{attrs:{"chart-data":_vm.amountOrderOfSpentRange.dataCollection,"options":_vm.amountOrderOfSpentRange.chartOptions}})
}
var staticRenderFns = []

export { render, staticRenderFns }